export const DEFAULT_DETAIL_ROW_HEIGHT = '600px';
export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_ROW_HEIGHT = 72;
export const DEFAULT_MAX_ROW_DATA_LENGTH_TO_HIDE_FILTERS = 3;

export const RangeStartFilterKeySuffix = 'RangeStart';
export const RangeEndFilterKeySuffix = 'RangeEnd';

export const MANAGE_FILTERS_EXPIRATION_TIME = 10 * 60 * 1000;
